import config from 'config';
import { getRequestId } from 'services/create-request-id';
import newRelicMonitoringService from 'services/new-relic-monitoring-service/new-relic-monitoring-service';

import type { RecaptchaTokenType } from './get-recaptcha-token.d';

/**
 * Get Google recaptcha token.
 *
 * @param username - User id.
 * @param action - Action.
 * @returns Recaptcha token.
 * https://cloud.google.com/recaptcha-enterprise/docs/actions-website?hl=pt-br
 */
export const getRecaptchaToken = async (
  username: RecaptchaTokenType['username'],
  action: RecaptchaTokenType['action']
) => {
  const sessionId = getRequestId();

  return new Promise((resolve) => {
    try {
      window.grecaptcha.enterprise.ready(async () => {
        try {
          const token = await window.grecaptcha.enterprise.execute(
            config.google.recaptcha.siteKey,
            {
              action,
            }
          );
          newRelicMonitoringService.addPageAction('callback_recaptcha_login', {
            event: 'analytics-event',
            event_name: 'callback_recaptcha_login',
            cd_interaction_action: action,
            cd_interaction_detail: 'sucesso',
            enduser_id: username,
            session_id: sessionId,
          });

          resolve(token);
        } catch (error) {
          newRelicMonitoringService.addError(error as Error, {
            login: username,
            name: 'recaptcha-error',
            step: 'recaptcha-invalid-input-secret',
            action,
            session_id: sessionId,
          });
          resolve('');
        }
      });
    } catch (error) {
      newRelicMonitoringService.addError(error as Error, {
        login: username,
        name: 'recaptcha-error',
        step: 'recaptcha-invalid-tracking-ready',
        action,
        session_id: sessionId,
      });

      resolve('');
    }
  });
};
